import { PagedResult } from "@king-ict/eupisi-ui/models";
import { api } from "@king-ict/eupisi-ui/utils/apiUtils";

import { OibIdentification, OibServiceResult, SaveResult } from "../../models";
import {
  User,
  Role,
  UserSearch,
  UserPermission,
  UserPermissionList,
} from "../../models/User";

const apiUrlPrefix: string = "users";

export const getUserById = async (id: number) => {
  return api.get(`${apiUrlPrefix}/get/${id}`) as Promise<User>;
};

export const searchUser = async (search: UserSearch) => {
  return api.post(`${apiUrlPrefix}/search`, search) as Promise<
    PagedResult<User>
  >;
};

export const saveUser = async (item: User) => {
  return api.post(`${apiUrlPrefix}/save`, item) as Promise<SaveResult<User>>;
};

export const getRoleList = async () => {
  return api.get(`${apiUrlPrefix}/get-roles`) as Promise<Role[]>;
};

export const getUserOibServiceData = async (oib: string) => {
  return api.get(`${apiUrlPrefix}/oib/${oib}`) as Promise<
    OibServiceResult<OibIdentification>
  >;
};

export const login = async () => {
  return api.get(`${apiUrlPrefix}/login`) as Promise<void>;
};

export const logout = async () => {
  return api.get(`${apiUrlPrefix}/logout`) as Promise<void>;
};

export const roleChange = async (id?: number) => {
  return api.get(
    id ? `${apiUrlPrefix}/role-change/${id}` : `${apiUrlPrefix}/role-change`
  ) as Promise<UserPermissionList>;
};

export const impersonate = async (userRoleId: number) => {
  return api.get(
    `${apiUrlPrefix}/impersonate/${userRoleId}`
  ) as Promise<UserPermission>;
};

export const unimpersonate = async () => {
  return api.get(`${apiUrlPrefix}/unimpersonate`) as Promise<UserPermission>;
};
